import React, { useCallback } from 'react';
import styles from "./MobileSelect.module.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function MobileSelectSelect({
  elements,
  activeItem,
  onSelection,
  children
}) {
  const handleSelect = useCallback(e => {
    return onSelection(elements.findIndex(({
      id
    }) => id === e.target.value));
  }, [elements, onSelection]);
  return /*#__PURE__*/_jsx("select", {
    className: styles.select,
    value: activeItem,
    onChange: handleSelect,
    children: children
  });
}